// 自定义指令集
//  v-positiveInt 限制正整数
//  v-tableDraggable="{callback:draggableBack}" 表格拖动 draggableBack->回调方法
//  v-hasPerm 获取是否有权限
import tableHeight from './components/tableHeight'
import dialogDrag from './components/dialogDrag'
import dragDom from './components/dragDom'
import positiveInt from './components/positive_int'
import tableDraggable from './components/tableDraggable'
import hasPerm from './components/has_perm'
import showMoney from './components/showMoney'
import showWeight from './components/showWeight'
import foldToggle from './components/fold_toggle'
import loginMask from './components/login_mask'
import tooltip from './components/tooltip'
const directives = {  //汇总自定义指令 // 此处可进行多个指令
    tableHeight,//表格自适应高度
    dialogDrag, //dialog拖拽
    dragDom,//拖拽DOM
    positiveInt,  //取整
    tableDraggable, //表格拖拽
    hasPerm, //鉴定权限
    showMoney,//显示钱
    showWeight,//显示重量
    foldToggle,//折叠切换
    loginMask,//登录遮罩
    tooltip,//
}
export default {  //导出自定义指令
    install(app) {// 以安装的方式插到app中
        Object.keys(directives).forEach((key) => {    // 遍历directives对象的key
            app.directive(key, directives[key])  // 将每个directive注册到app中
        })
    }
}